<template>
  <b-modal
    id="modal-confirm-topup"
    v-model="visibleModel"
    hide-header
    hide-footer
    centered
    body-class="p-[24px]"
    size="md"
  >
    <div class="flex gap-[16px] items-start py-8">
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
        alt="warning"
        class="w-[32px] h-[32px] mt-0"
      >
      <div class="flex flex-col flex-1">
        <h4 class="text-[18px] font-bold text-black mb-[8px]">
          {{ title }}
        </h4>
        <p class="text-[14px] text-[#333333] mb-[24px] leading-[22px] text-left">
          Are you sure you want to proceed? The transaction will be verified first and marked as <span class="font-bold">"{{ highlightText }}"</span> if the data matches
        </p>
        <div class="flex justify-end gap-[12px]">
          <b-button
            variant="outline-primary"
            class="border-[#E2E2E2] px-[20px] py-[8px] rounded-[6px] text-[14px] font-semibold"
            @click="handleCancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="px-[20px] py-[8px] rounded-[6px] text-[14px] font-semibold text-white"
            @click="handleConfirm"
          >
            Confirm
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalConfirm',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    trigger: {
      type: String,
      default: 'refund', // 'refund' | 'check'
    },
    item: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      visibleModel: false,
    }
  },
  computed: {
    title() {
      return this.trigger === 'refund' ? 'Cancel Top Up Kartu' : 'Check Top Up Kartu'
    },
    highlightText() {
      return this.trigger === 'refund' ? 'Refund' : 'Success'
    },
  },
  watch: {
    visible(newVal) {
      this.visibleModel = newVal
    },
    visibleModel(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    },
  },
  methods: {
    handleCancel() {
      this.visibleModel = false
    },
    handleConfirm() {
      this.$emit('confirm', { trigger: this.trigger, item: this.item })
      this.visibleModel = false
    },
  },
}
</script>

<style scoped>
/* Scoped styles */
</style>
